export const ROOT = 'giphy-player';

export const INSERT_GIF_BUTTON = 'insert-gif-button';
export const INSERT_GIF_MODAL = 'insert-gif-modal';
export const INSERT_GIF_MODAL_GIF_SEARCH_INPUT = 'insert-gif-modal-gif-search-input';
export const INSERT_GIF_MODAL_STICKER_SEARCH_INPUT = 'insert-gif-modal-sticker-search-input';
export const INSERT_GIF_MODAL_GIF_ITEM = 'insert-gif-modal-gif-item';
export const INSERT_GIF_MODAL_STICKER_ITEM = 'insert-gif-modal-sticker-item';
export const INSERT_GIF_MODAL_GIF_TAB = 'insert-gif-modal-gif-tab';
export const INSERT_GIF_MODAL_GIF_SELECTOR = 'insert-gif-modal-gif-selector';
